import React from 'react';
import { Button } from 'react-bootstrap';

const BlockedPopup = ({ lockedBy, errorMessage, onReturn }) => {
  const displayName = lockedBy || 'another user';
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center position-fixed top-0 start-0 w-100 vh-100 text-white"
      style={{ zIndex: 9999, background: 'rgba(0,0,0,0.7)' }}
    >
      <h2 style={{ color: '#ff4d4f' }}>{errorMessage ? 'Ticket unavailable for editing' : 'Ticket Locked'}</h2>
      {errorMessage ? (
        <p style={{ fontSize: '1.2rem', marginTop: '1rem' }}>{errorMessage}</p>
      ) : (
        <>
          <p style={{ fontSize: '1.2rem', marginTop: '1rem' }}>
            This ticket is currently being edited by <strong>{displayName}</strong>
          </p>
          <p style={{ fontSize: '0.9rem', color: '#ccc' }}>Please wait until they finish or contact them directly.</p>
        </>
      )}
      <Button variant="danger" onClick={onReturn} style={{ marginTop: '1rem' }}>
        Return to All Tickets
      </Button>
    </div>
  );
};

export default BlockedPopup;
